// Mirrors the Suite backend DTO returned from
// GET /public/document-templates/supported-tags/{sourceType}.
//
// Kept in sync manually with SupportedTagsDto.cs. Backend catalogs
// (ContractTagCatalog, SpecHomeTagCatalog, ChangeOrderTagCatalog) are the single
// source of truth for merge tags AND their display labels — the label dictionaries
// added in #2390 are optional so old servers stay compatible with new add-ins, and
// clients fall back to a local `toLabel()` derivation when a label is missing.

export enum DocumentTemplateSourceType {
  SpecHome = 1,
  Contract = 2,
  ChangeOrder = 3,
}

export const sourceTypeLabels: Record<DocumentTemplateSourceType, string> = {
  [DocumentTemplateSourceType.SpecHome]: 'Spec Home',
  [DocumentTemplateSourceType.Contract]: 'Contract',
  [DocumentTemplateSourceType.ChangeOrder]: 'Change Order',
};

export interface SupportedTagGroup {
  name: string;
  columns: string[];
}

export interface SupportedTags {
  sourceType: DocumentTemplateSourceType;
  fieldTags: string[];
  groups: SupportedTagGroup[];
  /** Optional per-tag human-readable labels, keyed by raw tag name. */
  fieldTagLabels?: Record<string, string> | null;
  /** Optional per-group human-readable labels, keyed by raw group name. */
  groupLabels?: Record<string, string> | null;
  /** Optional per-column labels — outer key is group, inner key is column. */
  groupColumnLabels?: Record<string, Record<string, string>> | null;
}
